import { render, staticRenderFns } from "./DetailBill.vue?vue&type=template&id=a5b4ba00"
import script from "./DetailBill.vue?vue&type=script&lang=js"
export * from "./DetailBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports